import { AppContext } from "App";
import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { ODOO_MARGIN_EDITOR } from "utils/permissions";
import CashflowPage from "./cashflow";
import CompanyDetail from "./cashflow/CompanyDetail";

const AccountingPages = () => {
  const { hasPermission } = useContext(AppContext);

  if (!hasPermission(ODOO_MARGIN_EDITOR))
    return (
      <div className="flex flex-1 items-center justify-center font-bold text-2xl h-screen text-gray-600">
        This page is not open to you yet.
      </div>
    );

  return (
    <Routes>
      <Route>
        <Route path="cashflow" element={<CashflowPage />} />
        <Route path="cashflow/:company" element={<CompanyDetail />} />
        <Route path="*" element={<div>404 Not Found.</div>} />
      </Route>
    </Routes>
  );
};

export default AccountingPages;
